<template>
    <el-dialog
        class="add-coupon"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add Coupon"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="rules"
                label-width="80px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Time" prop="time" size="small">
                            <el-date-picker
                                v-model="addForm.time"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="Start Time"
                                end-placeholder="End Time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Title" prop="name" size="small">
                            <el-input
                                v-model="addForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Discount" prop="value" size="small">
                            <el-input
                                v-model="addForm.value"
                                placeholder="Please input value"
                                ><template slot="append">% off</template></el-input
                            >
                        </el-form-item>
                        <el-form-item label="Desc" prop="desc" size="small">
                            <el-input
                                type="textarea"
                                v-model="addForm.desc"
                                placeholder="Please input desc"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                name: "",
                value: "",
                time: [],
                desc: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.addForm = {
                name: "",
                value: "",
                time: [],
                desc: "",
            }
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    let time = JSON.parse(JSON.stringify(this.addForm.time));
                    delete this.addForm.time;
                    cmofferApi
                        .couponList(
                            {
                                ...this.addForm,
                                start_time: time[0],
                                end_time: time[1],
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String,
    },
    watch: {
        addVisible(val) {},
    },
    computed:{
        ...mapState({
            pickerOptions: state => state.index.pickerOptions
        })
    }
};
</script>
<style lang="scss" scoped>
.add-coupon {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
